import { createUseStyles } from 'react-jss'

const useStyles = createUseStyles({
  center: {
    display: 'flex',
    justifyContent: 'center',
    width: '100%',
  },

  column: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '12px',
    width: '100%',
  },

  checkboxRow: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
  },

  checkboxRowDisabled: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    cursor: 'not-allowed',
    opacity: 0.5,
  },

  downloadLink: {
    color: '#bc31a2',
    textDecoration: 'underline',
    display: 'inline-flex',
    alignItems: 'center',
    gap: '6px',
    fontSize: '0.875rem',
    '&:hover': {
      color: '#9a2786',
    },
  },
})

export default useStyles
